"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportExpertPayment = exportExpertPayment;
exports.exportFinancialRevenue = exportFinancialRevenue;
exports.exportGeneralFeesReport = exportGeneralFeesReport;
exports.exportPerformance = exportPerformance;
exports.exportProjectRevenuesReport = exportProjectRevenuesReport;
exports.exportTeamPerformance = exportTeamPerformance;

var _api = _interopRequireWildcard(require("./api"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function exportTeamPerformance(month) {
  return _api["default"].get("/api/report/team-performance-export?month=".concat(month)).then(_api.extractData)["catch"](_api.errorHandler);
}

function exportPerformance(month) {
  return _api["default"].get("/api/report/performance-export?month=".concat(month)).then(_api.extractData)["catch"](_api.errorHandler);
}

function exportFinancialRevenue(query) {
  return _api["default"].post("/api/report/financial-revenue-export", query).then(_api.extractData)["catch"](_api.errorHandler);
}

function exportExpertPayment(query) {
  return _api["default"].get("/api/report/expert-payment/export?".concat(query)).then(_api.extractData)["catch"](_api.errorHandler);
}

function exportGeneralFeesReport(query) {
  return _api["default"].get("/api/report/export-general-fees?".concat(query)).then(_api.extractData)["catch"](_api.errorHandler);
}

function exportProjectRevenuesReport(query) {
  return _api["default"].get("/api/project/revenues-report?".concat(query)).then(_api.extractData)["catch"](_api.errorHandler);
}